import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-metro-summary-card',
  templateUrl: './metro-summary-card.component.html',
  standalone: false
})
export class MetroSummaryCardComponent {

  @Input() title!: string;
  @Input() value!: string;
  @Input() percentage!: string;
  @Input() loading: boolean = false;
  @Input() clickable: boolean = false;
  @Output() clicked = new EventEmitter<void>();

  get percentageColor(): string {
    if (!this.percentage) return 'text-gray-500';

    const clean = this.percentage.trim();
    if (clean.startsWith('+')) return 'text-green-600';
    if (clean.startsWith('-')) return 'text-red-600';
    return 'text-gray-500';
  }

  onCardClick(): void {
    if (this.clickable && !this.loading) {
      this.clicked.emit();
    }
  }

}
